import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

// Global Selectors
import {
    makeSelectHarvestEvent,
    makeSelectHarvestEventScheduledQuantity
} from 'services/harvestEvents/selectors';

// Constants
import { FORM_NAME } from './constants';

// Local Selectors
import { makeSelectContainerGroupValue } from '../../../../../../services/containerGroups/selectors';

type State = *;

interface Props {
    containerGroupId?: number | string;
}

const selectContainerGroupId = (state: State, props: Props) =>
    props.containerGroupId;

const makeSelectInitialValues = () =>
    createSelector(
        [
            makeSelectHarvestEvent(),
            makeSelectHarvestEventScheduledQuantity(),
            selectContainerGroupId,
            makeSelectContainerGroupValue('requestedQuantity')
        ],
        (
            harvestEventState,
            harvestEventScheduledQuantityState,
            containerGroupIdState,
            containerRequestedQuantityState
        ) => {
            if (!harvestEventState || !harvestEventState.harvestEvent) {
                return undefined;
            }

            return {
                numberOfLabels:
                    containerRequestedQuantityState ||
                    harvestEventScheduledQuantityState,
                ignoreWarningsForContainerGroupId: containerGroupIdState,
                harvestEvent: harvestEventState
            };
        }
    );

const formSelector = formValueSelector(FORM_NAME);

const makeSelectFormValue = field =>
    createSelector(
        state => formSelector(state, field),
        value => value
    );

export { makeSelectInitialValues, makeSelectFormValue };
